'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uploadFiles;

var _uploadFile = require('./uploadFile');

var _uploadFile2 = _interopRequireDefault(_uploadFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Upload list for files to project Documents
 *
 * @param {Object[]} files {file: string, name: string}[]
 * @return {Promise}
 */
function uploadFiles(files) {
    return Promise.all(files.map(function (file) {
        return (0, _uploadFile2.default)(file.file, file.name);
    }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/uploadFiles.js
// module id = 1044
// module chunks = 0